import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

const service = axios.create({
  baseURL: '/',
  timeout: 10000
})
service.interceptors.request.use(config => {
  const isToken = false
  if ( !isToken) {
    // config.headers['Authorization'] = 'Basic' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  if(config.params.token){
      config.headers['token'] = config.params.token;
  }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      let part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof(value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            let params = propName + '[' + key + ']';
            let subPart = encodeURIComponent(params) + "=";
            url += subPart + encodeURIComponent(value[key]) + "&";
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }else if(config.method === 'post' && config.params){
    config.data = config.params;
    config.params = null
  }
  if(config.type === 'file'){
    config.headers['Content-Type'] = 'multipart/form-data';
  }
  return config
}, error => {
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // debugger
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    if (code === 401) {
      MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('LogOut').then(() => {
          location.href = '/index';
        })
      })
    } else if (code === 500) {
      Message({
        message: '网络连接异常，请稍后重试！',
        type: 'error'
      })
      return Promise.reject(new Error(''))
    } else if (code === 400) {

      return res.data
    } else if (code !== 200) {
      // Message({
      //   message: '您发送的消息内有敏感字眼，请重新编辑发送！',
      //   type: 'error'
      // })
      return res.data
    } else {
      return res.data
    }
  },
  error => {
    let { message } = error;
    // if (message === "Network Error") {
    //   // message = "后端接口连接异常";
    //   message = "网络连接异常，请稍后重试！";
    // } else if (message.includes("timeout")) {
    //   // message = "系统接口请求超时";
    //   message = "网络连接异常，请稍后重试！";
    // } else if (message.includes("Request failed with status code")) {
    //   // message = "系统接口" + message.substr(message.length - 3) + "异常";
    //   message = "网络连接异常，请稍后重试！";
    // }
    // Message({
    //   message: message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/axios.js